// Scheduled Booking Constants
export const FETCH_SCHEDULED_BOOKINGS_REQUEST = "FETCH_SCHEDULED_BOOKINGS_REQUEST";
export const FETCH_SCHEDULED_BOOKINGS_SUCCESS = "FETCH_SCHEDULED_BOOKINGS_SUCCESS";
export const FETCH_SCHEDULED_BOOKINGS_FAIL = "FETCH_SCHEDULED_BOOKINGS_FAIL";

export const CREATE_SCHEDULED_BOOKING_REQUEST = "CREATE_SCHEDULED_BOOKING_REQUEST";
export const CREATE_SCHEDULED_BOOKING_SUCCESS = "CREATE_SCHEDULED_BOOKING_SUCCESS";
export const CREATE_SCHEDULED_BOOKING_FAIL = "CREATE_SCHEDULED_BOOKING_FAIL";

export const UPDATE_SCHEDULED_BOOKING_REQUEST = "UPDATE_SCHEDULED_BOOKING_REQUEST";
export const UPDATE_SCHEDULED_BOOKING_SUCCESS = "UPDATE_SCHEDULED_BOOKING_SUCCESS";
export const UPDATE_SCHEDULED_BOOKING_FAIL = "UPDATE_SCHEDULED_BOOKING_FAIL";

export const CANCEL_SCHEDULED_BOOKING_REQUEST = "CANCEL_SCHEDULED_BOOKING_REQUEST";
export const CANCEL_SCHEDULED_BOOKING_SUCCESS = "CANCEL_SCHEDULED_BOOKING_SUCCESS";
export const CANCEL_SCHEDULED_BOOKING_FAIL = "CANCEL_SCHEDULED_BOOKING_FAIL";

export const SET_ACTIVE_SCHEDULED_BOOKING = "SET_ACTIVE_SCHEDULED_BOOKING";
export const CLEAR_ACTIVE_SCHEDULED_BOOKING = "CLEAR_ACTIVE_SCHEDULED_BOOKING";

export const ADD_RESOURCE_ASSIGNMENT = "ADD_RESOURCE_ASSIGNMENT";
export const REMOVE_RESOURCE_ASSIGNMENT = "REMOVE_RESOURCE_ASSIGNMENT";
export const UPDATE_RESOURCE_ASSIGNMENT = "UPDATE_RESOURCE_ASSIGNMENT";

export const CLEAR_SCHEDULED_BOOKING_ERROR = "CLEAR_SCHEDULED_BOOKING_ERROR";
